import {$authHost, $host} from "./index";
// Получить компании пользователя через CompanyUser (новая структура)
export const getUserCompanies = async (userId) =>{
    const tokenStr = localStorage.getItem("token")
    try {
       let response = await $host.get(`api/company-user/user/${userId}`, { headers: {"Authorization" : `Bearer ${tokenStr}`} });
       return response.data;
    } catch (error) {
        console.log("error while calling getUserCompanies api", error.message);
    }
}

// Получить компанию по умолчанию для пользователя
export const getDefaultCompany = async (userId) =>{
    try {
       let response = await $authHost.get(`api/company-user/user/${userId}`);
       const companies = response.data;
       
       // Ищем компанию по умолчанию
       const defaultCompany = companies.find(cu => cu.isDefault && cu.status === 'active');
       
       if (defaultCompany && defaultCompany.company) {
         return defaultCompany.company;
       }
       
       // Если нет компании по умолчанию, берем первую активную
       const firstActive = companies.find(cu => cu.status === 'active');
       return firstActive ? firstActive.company : null;
    } catch (error) {
        console.log("error while calling getDefaultCompany api", error.message);
    }
}
export const getCompany = async (companyId) =>{
    try {
       let response = await $host.get(`api/companyprof/get`, {
         params: { companyId }
       });
       return response.data;
    } catch (error) {
        console.log("error while calling getCompany api", error.message);
    }
}

export const getCompanyCount = async (userId, count, prev) =>{
    try {
       let response = await $host.get(`api/companys/count/get/${userId}/${count}/${prev}`);
       return response.data;
    } catch (error) {
        console.log("error while calling getCompanyCount api", error.message);
    }
}

export const editCompany = async (data, id) =>{
    try {
        await $host.patch(`api/companyprof/update/${id}`, data); 
    } catch (error) {
        console.log("error while calling editCompany api",error.message);
    }
}

export const addCompany = async (data) =>{
    try {
        let response = await $host.post(`api/companyprof/add`, data); 
        return response.data;
    } catch (error) {
        console.log("error while calling addCompany api",error.message);
    }
}

export const deleteCompany = async (id) =>{
    try {
        await $host.delete(`api/companyprof/${id}`); 
    } catch (error) {
        console.log("error while calling deleteCompany api",error.message);
    }
}


export const getCompanyCountAll = async (userId) =>{
    try {
        let response = await $host.get(`api/companys/count/get/${userId}`); 
        return response.data; 
    } catch (error) {
        console.log("error while calling getCompanyCountAll api",error.message);
    }
}

//file
export const uploadAvatar = async (data) =>{
    try {
        return await $host.post(`api/file/upload`, data, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        });
    } catch (error) {
        console.log("error while calling uploadFile api",error.message);
        
    }
}



export const editCompanyProf = async (data, id) =>{
    try {
        await $host.patch(`api/companyprof/update/${id}`, data); 
    } catch (error) {
        console.log("error while calling editCompanyProf api",error.message);
    }
}

export const addCompanyProf = async (data) =>{
    try {
        let response = await $host.post(`api/companyprof/add`, data); 
        return response.data;
    } catch (error) {
        console.log("error while calling addCompanyProf api",error.message);
    }
}

export const getCompanyProfId = async (id) =>{
    try {
       let response = await $host.get(`api/companyprof/${id}`);
       return response.data;
    } catch (error) {
        console.log("error while calling getCompanyProfId api", error.message);
    }
}

// Методы для работы с Company (тенантом)
export const getCompanyById = async (id) =>{
    try {
       let response = await $authHost.get(`api/companies/${id}`);
       return response.data;
    } catch (error) {
        console.log("error while calling getCompanyById api", error.message);
    }
}

export const editCompanyTenant = async (data, id) =>{
    try {
        await $authHost.patch(`api/companies/${id}`, data); 
    } catch (error) {
        console.log("error while calling editCompanyTenant api",error.message);
    }
}

export const addCompanyTenant = async (data) =>{
    try {
        let response = await $authHost.post(`api/companies`, data); 
        return response.data;
    } catch (error) {
        console.log("error while calling addCompanyTenant api",error.message);
    }
}